import cn from "classnames";

export const WarningAlert = ({ message }: { message: string }) => {
  return (
    <div className={"flex flex-row items-center w-full justify-start gap-2"}>
      <svg className={"w-4 h-4 lg:w-6 lg:h-6"} viewBox="0 0 15 15" fill="none">
        <path
          d="M7.5 1C12.7 1 14 2.3 14 7.5C14 12.7 12.7 14 7.5 14C2.3 14 1 12.7 1 7.5C1 2.3 2.3 1 7.5 1ZM7.5 4.61111V7.5V4.61111ZM7.5 10.3889H7.50722H7.5Z"
          fill="#E7DEFF"
        />
        <path
          d="M7.5 4.61111V7.5M7.5 10.3889H7.50722M7.5 1C12.7 1 14 2.3 14 7.5C14 12.7 12.7 14 7.5 14C2.3 14 1 12.7 1 7.5C1 2.3 2.3 1 7.5 1Z"
          stroke="#8065C9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <p className={" md:text-lg font-normal text-primary"}>{message}</p>
    </div>
  );
};

interface ListAlertProps {
  list: string[];
  type?: "error" | "warning" | "success";
  title?: string;
}

export const ListAlert = ({ list, type, title }: ListAlertProps) => {
  return (
    <div
      className={`flex flex-col gap-2 ${
        type === "error"
          ? "bg-red-50 border-red-500 text-red-500"
          : type === "warning"
          ? "bg-yellow-50 border-yellow-500 text-yellow-500"
          : type === "success"
          ? "bg-green-50 border-green-500 text-green-500"
          : "bg-gray-50 border-gray-500 text-gray-500"
      } border-l-4 p-4`}
    >
      {title && <p className={"font-semibold text-sm md:text-base"}>{title}</p>}
      <ul className={"list-disc list-inside"}>
        {list.map((item, index) => (
          <li key={index} className={"text-xs md:text-sm"}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

interface AlertProps extends Omit<ListAlertProps, "list"> {
  message: string;
  className?: string;
}

export const Alert = ({ message, type, title, className }: AlertProps) => {
  return (
    <div
      className={cn(
        `flex flex-col gap-2 ${
          type === "error"
            ? "bg-red-50 border-red-500 text-red-500"
            : type === "warning"
            ? "bg-yellow-50 border-yellow-500 text-yellow-500"
            : type === "success"
            ? "bg-green-50 border-green-500 text-green-500"
            : "bg-gray-50 border-gray-500 text-gray-500"
        } border-l-4 p-4`,
        className,
      )}
    >
      {title && <p className={"font-semibold text-sm md:text-base"}>{title}</p>}
      <p className={"text-xs md:text-sm"}>{message}</p>
    </div>
  );
};
